import jQuery from "jquery";
jQuery(document).ready(function ($) {

    let hideLoadMoreSectorsProductsButton = function () {
        $('.show-more-sectors-products').addClass("inactive");
    }
    let $sectorProducts = $(".sectors-product-container .product-container");

    if ($sectorProducts.length <= 3)
        hideLoadMoreSectorsProductsButton();

    $('.show-more-sectors-products').on('click', function (event) {
        event.preventDefault();
        hideLoadMoreSectorsProductsButton();
        $(".sectors-product-container .product-container").removeClass("hidden");
        $(".sectors-product-container .product-container").addClass("visible");
        return false;
    });


});
